import { render, staticRenderFns } from "./activitypackageorder.vue?vue&type=template&id=6586b772"
import script from "./activitypackageorder.vue?vue&type=script&lang=js"
export * from "./activitypackageorder.vue?vue&type=script&lang=js"
import style0 from "./activitypackageorder.vue?vue&type=style&index=0&id=6586b772&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports